import React from 'react';
import { Switch } from 'react-router-dom';
import Route from './Route';

import SignIn from '~/pages/SignIn';
import SignUp from '~/pages/SignUp';

import Dashboard from '~/pages/Dashboard';
import Profile from '~/pages/Profile';

import AdminPanel from '~/pages/AdminPanel';
import QuestionEditor from '~/pages/AdminPanel/QuestionEditor';

export default function routes() {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/register" component={SignUp} />

      <Route path="/dashboard" component={Dashboard} isPrivate />
      <Route path="/profile" component={Profile} isPrivate />

      <Route path="/panel" exact component={AdminPanel} isPrivate onlyAdmin />
      <Route
        exact
        path="/panel/question/:question"
        component={QuestionEditor}
        isPrivate
        onlyAdmin
      />
    </Switch>
  );
}
